// extracted by mini-css-extract-plugin
export default {"label":"HeaderProposta_label__Qf9zo","containerLabels":"HeaderProposta_containerLabels__6kCcj","border":"HeaderProposta_border__9xO1w","boxLabels":"HeaderProposta_boxLabels__-e4hg"};